import { GET_COURT_CASE_REMINDER, GET_COURT_CASE_PENDING_REMINDER, GET_PENDING_LIAISON_REPORTS, GET_WO_FOR_MARKETING_EXPENSE, GET_WO_ITEM_FOR_MARKETING_EXPENSE, GET_ITEM_FOR_MARKETING_EXPENSE, GET_MARKETING_EXPENSE, GET_MARKETING_EXPENSE_DETAIL, GET_MARKETING_EXPENSE_EXPORT} from './types';

const initialState = {
    
   getWOForMarketingExpense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
     getWOItemForMarketingExpense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
getItemForMarketingExpense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
  getMarketingExpense: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
    getMarketingExpenseDetail: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
      getMarketingExpenseExport: {
    error: false,
    message: "",
    data: [],
    totalCount: 0
  },
}

const Marketing_reducer = (state = initialState, { type, payload }) => {
    switch(type)
    {
        case GET_WO_FOR_MARKETING_EXPENSE:
           return Object.assign({}, state, {
             getWOForMarketingExpense: payload
           });
            case GET_WO_ITEM_FOR_MARKETING_EXPENSE:
           return Object.assign({}, state, {
             getWOItemForMarketingExpense: payload
           });
                 case GET_ITEM_FOR_MARKETING_EXPENSE:
           return Object.assign({}, state, {
             getItemForMarketingExpense: payload
           });
                      case GET_MARKETING_EXPENSE:
           return Object.assign({}, state, {
             getMarketingExpense: payload
           });
                        case GET_MARKETING_EXPENSE_DETAIL:
           return Object.assign({}, state, {
             getMarketingExpenseDetail: payload
           });
                             case GET_MARKETING_EXPENSE_EXPORT:
           return Object.assign({}, state, {
             getMarketingExpenseExport: payload
           });
        default:  
            return state;
    }
}

export default Marketing_reducer;